// Generated by purs version 0.15.4
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Web_HTML_Common from "../Web.HTML.Common/index.js";
var css = function ($1) {
    return Halogen_HTML_Properties.class_(Web_HTML_Common.ClassName($1));
};
export {
    css
};
